import { LegacyRef, ReactNode } from 'react';
import clsx from 'clsx';

interface SquareCardProps {
  innerRef?: LegacyRef<HTMLDivElement>;
  children?: ReactNode;
  className?: string;
}

export default function SquareCard({ innerRef, children, className }: SquareCardProps) {
  return (
    <div className={clsx('bg-white border border-[#3e3e3e]', className)} ref={innerRef}>
      {children}
    </div>
  );
}
